<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->

<div fxLayout="column" id="itemRecordContainer">
  <record-text [text]="record.hintTitle"></record-text>
  <record-text [text]="record.hintText"></record-text>
  <div fxLayout="row" id="recordBarcodesContainer" *ngFor="let barcode of record.barcodes">
    <record-icon-text
      [matTooltip]="getTooltipForBarcode(barcode)"
      matTooltipClass="preserve-newlines"
      matTooltipPosition="after"
      [icon]="faBarcodeScan"
      [text]="barcode.barcode"
    ></record-icon-text>
    <div class="record-barcodes-spacer expand"></div>
    <mat-chip-set style="flex: 0 0 auto">
      <mat-chip
        *ngIf="barcode.scanState === ScanState.SCANNED"
        class="epg-status-chip-success scan-state"
        style="text-transform: lowercase"
        i18n="@@barcodeScanned"
        >Scanned</mat-chip
      >
      <mat-chip
        *ngIf="barcode.scanState === ScanState.MANUAL"
        class="epg-status-chip-info scan-state"
        style="text-transform: lowercase"
        i18n="@@barcodeEnteredManually"
        >Entered manually</mat-chip
      >
      <mat-chip
        *ngIf="barcode.scanState === ScanState.NOT_SCANNED"
        class="epg-status-chip-error scan-state"
        style="text-transform: lowercase"
        i18n="@@barcodeNotScanned"
        >Not scanned</mat-chip
      >
    </mat-chip-set>
  </div>
</div>
